const url = "/esferagovernos";
const id = "id"

export function pesquisarAll() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/all`).then((res) => {
            resolve(res.data);
        })
    })
  }